import state from './moduleStockImagesState'
import actions from './moduleStockImagesActions'
import getters from './moduleStockImagesGetters'
import mutations from './moduleStockImagesMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
